module.exports = __webpack_public_path__ + "static/img/12.248ac5c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/trainPlan/10sportDesc/12.svg
// module id = pIcE
// module chunks = 0